import $api from '../services';

export default {
    getEncryptedSecretByPublicKey(public_key) {
        const data = new FormData();
        data.append('public_key', public_key);
        return $api.post('/get_encrypted_secret_by_public_key', data);
    },
    getPublicKeysWithoutSecret() {
        return $api.post(`/get_public_keys_without_secret`);
    },
    uploadPublicKey(public_key) {
        const data = new FormData();
        data.append('public_key', public_key);
        return $api.post('/upload_public_key', data);
    },
    uploadEncryptedSecrets(encryptedSecrets) {
        return $api.post('/upload_encrypted_secrets', encryptedSecrets);
    },
};
